<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>考试</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_l">
          <div class="content_box_l_title">
            <Countdown :time="time" format="hh:mm:ss" @on-end="onCountdownEnd">
              <template slot-scope="{ time }">考试剩余时间 {{ time }}</template>
            </Countdown>
          </div>
          <!-- 答题卡 -->
          <div class="topic_card">
            <div class="card_alt clearfix">
              <div class="card_alt_item clearfix">
                <span class="huang"></span>已作答
              </div>
              <div class="card_alt_item">
                <span></span>未作答
              </div>
              <div class="card_alt_item">
                <span class="red"></span>当前题
              </div>
              <div class="card_alt_item">
                <span class="mark"></span>标记
              </div>
            </div>
            <div class="topic_card_box">
              <div class="topic_card_item" v-for="(item,index) in questionTypes" :key="index">
                <div class="card_item_title">{{item.type_name}}</div>
                <div class="card_box clearfix">
                  <div
                    class="number_list"
                    :class="[answe_obj.hasOwnProperty(item1.question_id)?(current_index+1==item1.i?'red':'huang'):(current_index+1==item1.i?'red':''),mark_list[item1.i-1] ==true? 'mark':'' ]"
                    v-for="(item1,index) in item.questions"
                    :key="index"
                    @click="card_cl(item1.i)"
                  >{{item1.i}}</div>
                </div>
              </div>
            </div>

            <div class="new_make huang" @click="open">交卷</div>
          </div>
        </div>
        <div class="content_box_r">
          <div class="work_box">
            <!-- 题 -->
            <div
              class="work_box_content"
              v-for="(item,index) in exam_list"
              :key="index"
              v-show="index == current_index"
            >
              <!-- 单选题 -->
              <div class="min_box">
                <div class="topic_box" v-if="item.type ==1">
                  <div class="topic_top clearfix">
                    <div class="number">
                      <span>{{index+1}}</span>
                      /{{exam_list.length}}
                    </div>
                    <div class="type">{{item.type_name}}</div>
                  </div>
                  <div class="topic_bottom">
                    <div class="work_name" v-html="item.parentStem"></div>
                    <div class="work_name" v-html="item.stem"></div>

                    <div class="answer">
                      <div
                        class="answer_list clearfix"
                        v-for="(item1,i) in item.metas"
                        :key="i"
                        @click="checkAnswer(i,item,item.id ,item1.key)"
                      >
                        <span :class="answer_state_list[index][i]">{{item1.key}}</span>
                        <!-- <div class="work_key" v-html="item1.meta"></div> -->
                        <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                      </div>
                    </div>
                  </div>

                  <div class="operate_box clearfix">
                    <div class="operate_box_l clearfix">
                      <div class="up" @click="up_click">上一题</div>
                      <div class="next" @click="next_click">下一题</div>
                    </div>
                    <div class="operate_box_r clearfix">
                      <div class="mark">
                        <div
                          class="mark_c"
                          :class="mark_list[current_index]==true? 'huang':'' "
                          @click="mark_click"
                        ></div>标记
                      </div>
                      <div class="faver" @click="collection_click">
                        <img
                          v-if="exam_list[current_index].is_favorite ==1"
                          src="../assets/img/favorite.png"
                          alt
                        />
                        <img v-else src="../assets/img/favorite1.png" alt />
                        {{exam_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多选 -->
              <div class="min_box">
                <div class="topic_box" v-if="item.type ==2">
                  <div class="topic_top clearfix">
                    <div class="number">
                      <span>{{index+1}}</span>
                      /{{exam_list.length}}
                    </div>
                    <div class="type">{{item.type_name}}</div>
                  </div>
                  <div class="topic_bottom">
                    <div class="work_name" v-html="item.parentStem"></div>
                    <div class="work_name" v-html="item.stem"></div>

                    <div class="answer">
                      <div
                        class="answer_list clearfix"
                        v-for="(item1,i) in item.metas"
                        :key="i"
                        @click="checkAnswer(i,item,item.id ,item1.key)"
                      >
                        <span class="more" :class="answer_state_list[index][i]">{{item1.key}}</span>
                        <!-- <div class="work_key" v-html="item1.meta"></div> -->
                        <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                      </div>
                    </div>
                  </div>
                  <!-- 确定按钮 -->
                  <div class="certain" v-show="false">
                    <div
                      class="certain_btn huang"
                      v-if="more_list[index]"
                      @click="fix_click(item)"
                    >确定</div>
                    <div class="certain_btn" v-else>确定</div>
                  </div>
                  <div class="operate_box clearfix">
                    <div class="operate_box_l clearfix">
                      <div class="up" @click="up_click">上一题</div>
                      <div class="next" @click="next_click">下一题</div>
                    </div>
                    <div class="operate_box_r clearfix">
                      <div class="mark">
                        <div
                          class="mark_c"
                          :class="mark_list[current_index]==true? 'huang':'' "
                          @click="mark_click"
                        ></div>标记
                      </div>
                      <div class="faver" @click="collection_click">
                        <img
                          v-if="exam_list[current_index].is_favorite ==1"
                          src="../assets/img/favorite.png"
                          alt
                        />
                        <img v-else src="../assets/img/favorite1.png" alt />
                        {{exam_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 判断 -->
              <div class="min_box">
                <div class="topic_box" v-if="item.type ==3">
                  <div class="topic_top clearfix">
                    <div class="number">
                      <span>{{index+1}}</span>
                      /{{exam_list.length}}
                    </div>
                    <div class="type">{{item.type_name}}</div>
                  </div>
                  <div class="topic_bottom">
                    <div class="work_name" v-html="item.parentStem"></div>
                    <div class="work_name" v-html="item.stem"></div>

                    <div class="answer">
                      <div
                        class="answer_list clearfix"
                        v-for="(item1,i) in item.metas"
                        :key="i"
                        @click="checkAnswer(i,item,item.id ,item1.key)"
                      >
                        <span :class="answer_state_list[index][i]">{{item1.key}}</span>
                        <!-- <div class="work_key" v-html="item1.meta"></div> -->
                        <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                      </div>
                    </div>
                  </div>

                  <div class="operate_box clearfix">
                    <div class="operate_box_l clearfix">
                      <div class="up" @click="up_click">上一题</div>
                      <div class="next" @click="next_click">下一题</div>
                    </div>
                    <div class="operate_box_r clearfix">
                      <div class="mark">
                        <div
                          class="mark_c"
                          :class="mark_list[current_index]==true? 'huang':'' "
                          @click="mark_click"
                        ></div>标记
                      </div>
                      <div class="faver" @click="collection_click">
                        <img
                          v-if="exam_list[current_index].is_favorite ==1"
                          src="../assets/img/favorite.png"
                          alt
                        />
                        <img v-else src="../assets/img/favorite1.png" alt />
                        {{exam_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 不定项 -->
              <div class="min_box">
                <div class="topic_box" v-if="item.type ==4">
                  <div class="topic_top clearfix">
                    <div class="number">
                      <span>{{index+1}}</span>
                      /{{exam_list.length}}
                    </div>
                    <div class="type">{{item.type_name}}</div>
                  </div>
                  <div class="topic_bottom">
                    <div class="work_name" v-html="item.parentStem"></div>
                    <div class="work_name" v-html="item.stem"></div>

                    <div class="answer">
                      <div
                        class="answer_list clearfix"
                        v-for="(item1,i) in item.metas"
                        :key="i"
                        @click="checkAnswer(i,item,item.id ,item1.key)"
                      >
                        <span class="more" :class="answer_state_list[index][i]">{{item1.key}}</span>
                        <!-- <div class="work_key" v-html="item1.meta"></div> -->
                        <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                      </div>
                    </div>
                  </div>
                  <!-- 确定按钮 -->
                  <div class="certain" v-show="false">
                    <div
                      class="certain_btn huang"
                      v-if="more_list[index]"
                      @click="fix_click(item)"
                    >确定</div>
                    <div class="certain_btn" v-else>确定</div>
                  </div>
                  <div class="operate_box clearfix">
                    <div class="operate_box_l clearfix">
                      <div class="up" @click="up_click">上一题</div>
                      <div class="next" @click="next_click">下一题</div>
                    </div>
                    <div class="operate_box_r clearfix">
                      <div class="mark">
                        <div
                          class="mark_c"
                          :class="mark_list[current_index]==true? 'huang':'' "
                          @click="mark_click"
                        ></div>标记
                      </div>
                      <div class="faver" @click="collection_click">
                        <img
                          v-if="exam_list[current_index].is_favorite ==1"
                          src="../assets/img/favorite.png"
                          alt
                        />
                        <img v-else src="../assets/img/favorite1.png" alt />
                        {{exam_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 简答 -->
              <div class="min_box">
                <div class="topic_box" v-if="item.type >4">
                  <div class="topic_top clearfix">
                    <div class="number">
                      <span>{{index+1}}</span>
                      /{{exam_list.length}}
                    </div>
                    <div class="type">{{item.type_name}}</div>
                  </div>
                  <div class="topic_bottom">
                    <div class="work_name" v-html="item.parentStem"></div>
                    <div class="work_name" v-html="item.stem"></div>
                    <div class="answer">
                      <el-input
                        type="textarea"
                        :rows="4"
                        :placeholder="answer_state_list[current_index][0]"
                        resize="none"
                        v-model="value"
                        @input="input_value"
                        @blur="input_blur(index,item)"
                      ></el-input>
                    </div>
                  </div>

                  <div class="operate_box clearfix">
                    <div class="operate_box_l clearfix">
                      <div class="up" @click="up_click">上一题</div>
                      <div class="next" @click="next_click">下一题</div>
                    </div>
                    <div class="operate_box_r clearfix">
                      <div class="mark">
                        <div
                          class="mark_c"
                          :class="mark_list[current_index]==true? 'huang':'' "
                          @click="mark_click"
                        ></div>标记
                      </div>
                      <div class="faver">
                        <img
                          v-if="exam_list[current_index].is_favorite ==1"
                          src="../assets/img/favorite.png"
                          alt
                        />
                        <img v-else src="../assets/img/favorite1.png" alt />
                        {{exam_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Countdown from "@choujiaojiao/vue2-countdown";
import { Exam, SaveFavorite, SaveExam,ExamResult } from "@/api/index.js";
import zgContent from '@/components/zgContent'
export default {
  components: { Countdown },
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      value: "", //shurudaan
      show: false, //控制答题卡显示
      Chan_show: false, //控制交卷提醒
      time_out_show: false, //时间结束弹窗
      close_show: false, //点击关闭提示
      time: 0,
      exam_list: [], //试题
      current_index: 0, //当前题目下标
      Jump_index: 0, //跳转的index
      answer_state_list: [], //二维数组
      answe_obj: {}, //每道题的答案
      active_list: [], //多选题选中的答案
      moreArr: [], //
      more_list: [], //记录多选题确定按钮的显示隐藏
      mark_list: [], //是否标记
      sum: 0,
      questionTypes: [], //答题卡,
      noneSum: 0, //未做题的数量
      obj: {}, //参数
      begin_time: 0,
      Arr: [],
      sumArr: [], //多选题按钮的判断
      levelList: {},
    };
  },
  created(){
    this.$layer.closeAll('iframe');
  },
  mounted() {
    this.$utils.banCopy()
    let obj = {};
    obj.course_id = this.$route.query.course_id;
    obj.test_id = this.$route.query.test_id;
    obj.rule_tag = this.$route.query.rule_tag;
    obj.course_chapter_id = this.$route.query.course_chapter_id;
    // obj.cid = this.$route.query.cid;
    this.requery(obj);
    this.obj = obj;
    
  },
  methods: {
    requery(obj) {
      Exam(obj).then(res => {
        this.time = res.limited_time * 60;
        this.questionTypes = res.questionTypes;
        this.begin_time = res.begin_time;
        this.exam_list = res.questionList;
        for (let i = 0; i < this.exam_list.length; i++) {
          this.answer_state_list[i] = [];
          this.more_list[i] = false;
          this.active_list[i] = [];
          this.sumArr[i] = 0;
          this.mark_list[i] = false;
        }
        console.log(this.time);
      });
    },
    //收藏题目
    saveFavorite(id) {
      SaveFavorite(id).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success"
          });
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    // 保存考试
    saveExam(obj) {
      obj.course_chapter_id = this.$route.query.course_chapter_id
      SaveExam(obj).then(res => {
      //是否有主观题
        let num = 0
        for(let item of this.questionTypes){
          num=item.question_type
        }
        if(num<=4){
          if(this.$route.query.is_zujuan==1){
            this.$router.push({
              path: "reportZujuan",
              query: { id: res.id, exam: "exam" }
            });
            return
          }else{
            return this.$router.push({
              path: "report",
              query: { id: res.id, exam: "exam" }
            });
          }
        }
      //v3主观题
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("i", { style: "color: red;font-style:normal" }, '考试已结束，主观题部分分数，请对比答案解析后，手动输入所得分数！')
        ]),
        showCancelButton: true,
        distinguishCancelAndClose: true,//重点：区分关闭和取消
        confirmButtonText: "直接查看成绩",
        cancelButtonText: "给主观题打分",
        confirmButtonClass:"zg_report",
        cancelButtonClass:"zg_dafen",
      }).then(action => {
        if(this.$route.query.is_zujuan==1){
          this.$router.push({
            path: "reportZujuan",
            query: { id: res.id, exam: "exam" }
          });
          return
        }else{
          return this.$router.push({
            path: "report",
            query: { id: res.id, exam: "exam" }
          });
        }
      }).catch(action=>{
        if(action === 'cancel'){
          //弹窗
          let obj = {result_id:res.id};
          this.getExamResult(obj)
        }else{
          //取消=>进入报告
          if(this.$route.query.is_zujuan==1){
            this.$router.push({
              path: "reportZujuan",
              query: { id: res.id, exam: "exam" }
            });
            return
          }else{
            return this.$router.push({
              path: "report",
              query: { id: res.id, exam: "exam" }
            });
          }
        }
      })

      });
    },
    getExamResult(obj){
      ExamResult(obj).then(res=>{
        // this.$layer.closeAll('iframe');
        //显示主观弹窗
        let layerId = this.$layer.iframe({
          id: 1,
          type: 2,
          title: '给主观题打分',
          area:['800px','590px'],
          shade:0,
          zIndex :525,
          shade: true,
          shadeClose: false,
          content: {
            content: zgContent, //传递的组件对象
            parent: this,//当前的vue对象
            data:{
                zgData:res
            }
          },
          cancel:()=>{
            this.$layer.closeAll('iframe');
            if(this.$route.query.is_zujuan==1){
              this.$router.push({
                path: "reportZujuan",
                query: { id: res.id, exam: "exam" }
              });
              return
            }else{
              return this.$router.push({
                path: "report",
                query: { id: res.id, exam: "exam" }
              });
            }
          }
        });

      })
    },
    close_click() {
      this.close_show = true;
    },
    // 退出
    close_exam() {
      this.close_show = false;
      this.$router.go(-1);
    },
    keep_click() {
      this.Chan_show = false;
      this.close_show = false;
      this.noneSum = 0;
    },
    // 改变二维数组的值
    changeArrValue(arr, index, jndex, value) {
      let array = arr[index];
      array[jndex] = value;
      arr.splice(index, 1, array);
      // console.log(this.answer_state_list);
    },
    // 选中
    checkAnswer(index, items, id, key) {
      // 单选

      // let id1 = id.toString()
      if (items.type == 1 || items.type == 3) {
        console.log(key);
        if (this.answer_state_list[this.current_index].length > 0) {
          this.answer_state_list[this.current_index] = [];
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-check"
          );
          this.answe_obj[id.toString()] = key;
          console.log(this.answe_obj);
        } else {
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-check"
          );
          this.answe_obj[id.toString()] = key;
          console.log(this.answe_obj);
        }
        // console.log(this.answe_obj);
      } else if (items.type == 2) {
        // 多选

        // 点击选中
        if (
          this.answer_state_list[this.current_index][index] == "answer-check"
        ) {
          console.log(this.moreArr)
          this.$set(this.moreArr, index, "");
          console.log(this.moreArr);

          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            " "
          );
          console.log(this.answer_state_list);

          for (
            let j = 0;
            j < this.answer_state_list[this.current_index].length;
            j++
          ) {
            // console.log(this.answer_state_list[this.current_index][j]);
            if (
              this.answer_state_list[this.current_index][j] != "answer-check"
            ) {
              this.sumArr[this.current_index] -= 1;
            }
          }
          console.log(this.sumArr);
          if (this.sumArr[this.current_index] > 0) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          let strMorArr = this.moreArr.join("");
          this.answe_obj[id.toString()] = strMorArr;
        } else {
          // 判断确定按钮

          this.$set(this.moreArr, index, items.metas[index].key);
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-check"
          );

          this.sumArr[this.current_index] = 0;
          for (
            let j = 0;
            j < this.answer_state_list[this.current_index].length;
            j++
          ) {
            // console.log(this.answer_state_list[this.current_index][j]);
            if (
              this.answer_state_list[this.current_index][j] == "answer-check"
            ) {
              this.sumArr[this.current_index] += 1;
              console.log(this.sumArr[this.current_index]);
            }
          }
          if (this.sumArr[this.current_index] > 1) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          let strMorArr = this.moreArr.join("");

          this.answe_obj[id.toString()] = strMorArr;
        }
      } else if (items.type == 4) {
        // 不定项
        // 点击选中
        if (
          this.answer_state_list[this.current_index][index] == "answer-check"
        ) {
          this.$set(this.moreArr, index, "");
          console.log(this.moreArr);

          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            " "
          );
          console.log(this.answer_state_list);
          this.sumArr[this.current_index] = 0;
          for (
            let j = 0;
            j < this.answer_state_list[this.current_index].length;
            j++
          ) {
            console.log(this.answer_state_list[this.current_index][j]);
            if (
              this.answer_state_list[this.current_index][j] == "answer-check"
            ) {
              this.sumArr[this.current_index] += 1;
            }
          }
          console.log(this.sumArr[this.current_index]);
          if (this.sumArr[this.current_index] > 0) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          let strMorArr = this.moreArr.join("");
          this.answe_obj[id.toString()] = strMorArr;
        } else {
          // 判断确定按钮

          this.$set(this.moreArr, index, items.metas[index].key);
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-check"
          );

          this.sumArr[this.current_index] = 0;
          for (
            let j = 0;
            j < this.answer_state_list[this.current_index].length;
            j++
          ) {
            // console.log(this.answer_state_list[this.current_index][j]);
            if (
              this.answer_state_list[this.current_index][j] == "answer-check"
            ) {
              this.sumArr[this.current_index] += 1;
              console.log(this.sumArr[this.current_index]);
            }
          }
          if (this.sumArr[this.current_index] > 0) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          let strMorArr = this.moreArr.join("");
          this.answe_obj[id.toString()] = strMorArr;
          // console.log(this.answer_state_list);
        }
      }
    },
    // 点击确定
    fix_click(item) {
      this.sum = 0;
      console.log(this.moreArr);
      let strMorArr = this.moreArr.join("");
      this.answe_obj[item.id.toString()] = strMorArr;
      this.moreArr = [];
      if (this.current_index == this.answer_state_list.length - 1) {
      } else {
        this.current_index += 1;
      }
    },

    card_show() {
      this.show = true;
    },
    // 点击答题卡序号
    card_cl(i) {
      this.Jump_index = i - 1;
      this.current_index = i - 1;
      this.sum = 0;
      this.moreArr = [];
      // 恢复答题内容--修复为填空题
      if(this.exam_list[i-1].type>4){
        if(this.answer_state_list[i-1].length>0){
          this.value = this.answer_state_list[i-1][0]
        }
        else
            this.value=''
      }else if(this.exam_list[i-1].type==2||this.exam_list[i-1].type==4){
        for(let index=0;index<this.answer_state_list[i-1].length;index++){
          if(this.answer_state_list[i-1][index]){
            if(index==0){
              this.$set(this.moreArr, index, 'A');
            }else if(index==1){
              this.$set(this.moreArr, index, 'B');
            }else if(index==2){
              this.$set(this.moreArr, index, 'C');
            }else if(index==3){
              this.$set(this.moreArr, index, 'D');
            }
          }
        }
      }

      if (this.sum >= 2) {
        this.$set(this.more_list, this.current_index, true);
      } else {
        this.$set(this.more_list, this.current_index, false);
      }
    },
    // 点击收藏
    collection_click() {
      if (this.exam_list[this.current_index].is_favorite == 1) {
        this.exam_list[this.current_index].is_favorite = 0;
      } else {
        this.exam_list[this.current_index].is_favorite = 1;
      }
      this.saveFavorite(this.exam_list[this.current_index].id);
    },
    mark_click() {
      console.log(111);
      console.log(this.mark_list);
      this.$set(
        this.mark_list,
        this.current_index,
        !this.mark_list[this.current_index]
      );
    },
    // 简答题
    input_blur(index, item) {
      this.changeArrValue(
        this.answer_state_list,
        this.current_index,
        0,
        this.value
      );
      this.answe_obj[item.id.toString()] = this.value;
      this.value = "";
      //焦点bug修复
      if(this.current_index==index){
        //恢复
        this.value = this.answer_state_list[this.current_index][0]
      }
    },
    input_value(value) {
      console.log(value);
      this.value = value;
    },
    up_click() {
      if (this.current_index == 0) {
      } else {
        this.current_index -= 1;
        this.moreArr = [];
        this.sum = 0;
        // 恢复答题内容
        // if(this.answer_state_list[this.current_index].length>0)
        //   this.value = this.answer_state_list[this.current_index][0]
        // else
        //   this.value=''

        // 恢复答题内容--修复为填空题
        if(this.exam_list[this.current_index].type>4){
          if(this.answer_state_list[this.current_index].length>0){
            this.value = this.answer_state_list[this.current_index][0]
          }
          else
              this.value=''
        }else if(this.exam_list[this.current_index].type==2||this.exam_list[this.current_index].type==4){
          for(let index=0;index<this.answer_state_list[this.current_index].length;index++){
            if(this.answer_state_list[this.current_index][index]){
              if(index==0){
                this.$set(this.moreArr, index, 'A');
              }else if(index==1){
                this.$set(this.moreArr, index, 'B');
              }else if(index==2){
                this.$set(this.moreArr, index, 'C');
              }else if(index==3){
                this.$set(this.moreArr, index, 'D');
              }
            }
          }
        }



      }
      console.log(this.answer_state_list);
      console.log(this.answe_obj);
    },
    next_click() {
      if (this.current_index == this.answer_state_list.length - 1) {
      } else {
        this.current_index += 1;
        this.moreArr = [];
        this.sum = 0;
        // 恢复答题内容
        if(this.answer_state_list[this.current_index].length>0)
          this.value = this.answer_state_list[this.current_index][0]
        else
          this.value=''
      }
    },
    open() {
      for (let i = 0; i < this.answer_state_list.length; i++) {
        if (this.answer_state_list[i].length == 0) {
          this.noneSum += 1;
        }
      }
      const h = this.$createElement;
      if(this.noneSum==0){
        let examObj = {};
        examObj.test_id = this.obj.test_id;
        examObj.course_id = this.obj.course_id;
        examObj.cid = this.obj.cid;
        examObj.begin_time = this.begin_time;
        examObj.item_count = this.answer_state_list.length;
        examObj.answers = JSON.stringify(this.answe_obj);
        this.saveExam(examObj);
      }else{
        this.$msgbox({
          title: "提示",
          message: h("p", null, [
            h("span", null, "你还有 "),
            h("i", { style: "color: red;font-style:normal" }, this.noneSum),
            h("span", null, "道题未做，确定交卷吗？")
          ]),
          showCancelButton: true,
          confirmButtonText: "确定交卷",
          cancelButtonText: "继续做题",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              let examObj = {};
              examObj.test_id = this.obj.test_id;
              examObj.course_id = this.obj.course_id;
              examObj.cid = this.obj.cid;
              examObj.begin_time = this.begin_time;
              examObj.item_count = this.answer_state_list.length;
              examObj.answers = JSON.stringify(this.answe_obj);
              this.saveExam(examObj);
              done();
            } else {
              this.noneSum = 0;
              done();
            }
          }
        }).then(action => {
          this.noneSum = 0;
        });
      }


    },
    onCountdownEnd() {
      //   console.log("结束");
      this.open_time_out();
    },
    // 倒计时结束
    open_time_out() {
      this.$alert("考试时间到", "提示", {
        confirmButtonText: "交卷",
        callback: action => {
          let examObj = {};
          examObj.test_id = this.obj.test_id;
          examObj.course_id = this.obj.course_id;
          examObj.cid = this.obj.cid;
          examObj.begin_time = this.begin_time;
          examObj.item_count = this.answer_state_list.length;
          examObj.answers = JSON.stringify(this.answe_obj);
          this.saveExam(examObj);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 422px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .topic_card {
        padding: 0 42px;
        .card_alt {
          padding-bottom: 21px;
          border-bottom: 1px solid #eee;
          margin-bottom: 34px;
          .card_alt_item {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 12px;
            margin-right: 18px;
            span {
              float: left;
              display: block;
              width: 12px;
              height: 12px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(204, 204, 204, 1);
              border-radius: 50%;
              margin-right: 5px;
            }
            .red {
              background: rgba(232, 66, 51, 0.2);
              border: 1px solid rgba(232, 66, 51, 1);
            }
            .lv {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
            }
            .huang {
              background: rgba(250, 220, 30, 0.2);
              border: 1px solid rgba(250, 220, 30, 1);
            }
            .mark {
              background: rgba(250, 220, 30, 1);
              border: 1px solid rgba(204, 204, 204, 1);
            }
          }
        }
        .topic_card_box {
          height: 500px;
          overflow-y: scroll;
          margin-bottom: 30px;
          .topic_card_item {
            margin-bottom: 34px;
            .card_item_title {
              font-size: 16px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 21px;
            }
            .card_box {
              border-bottom: 1px solid #eee;
              .number_list {
                cursor: pointer;
                float: left;
                width: 34px;
                height: 34px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                font-size: 14px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 34px;
                border-radius: 50%;
                margin-right: 35px;
                margin-bottom: 20px;
                &:nth-of-type(5n) {
                  margin-right: 0;
                }
              }
              .lv {
                background: rgba(12, 213, 109, 0.2);
                border: 1px solid rgba(12, 213, 109, 1);
                color: rgba(12, 213, 109, 1);
              }
              .huang {
                background: rgba(250, 220, 30, 0.2);
                border: 1px solid rgba(250, 220, 30, 1);
              }
              .red {
                background: rgba(232, 66, 51, 0.2) !important;
                border: 1px solid rgba(232, 66, 51, 1) !important;
                color: rgba(232, 66, 51, 1) !important;
              }
              .mark {
                background: rgba(250, 220, 30, 1);
                border: 1px solid rgba(204, 204, 204, 1);
              }
            }
          }
        }
        /*修改滚动条样式*/
        .topic_card_box::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .topic_card_box::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .topic_card_box::-webkit-scrollbar-thumb {
          background: #fadc1e;
          border-radius: 10px;
        }
        .topic_card_box::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .topic_card_box::-webkit-scrollbar-corner {
          background: #179a16;
        }
        .new_make {
          cursor: pointer;
          width: 258px;
          height: 37px;
          background: rgba(238, 238, 238, 0.6);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          line-height: 37px;
          margin: 0 auto 50px auto;
        }
        .huang {
          background-color: #fadc1e;
        }
      }
    }
    .content_box_r {
      float: right;
      width: 913px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_r_title {
        padding: 20px 0 24px 51px;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        border-bottom: 1px solid #eee;
        img {
          float: left;
          width: 31px;
          height: 32px;
          margin-right: 16px;
        }
      }
      .work_box {
        padding: 0 50px 80px 50px;

        .work_box_title {
          padding: 21px 0;
          border-bottom: 1px solid #eee;
          .name {
            cursor: pointer;
            float: left;
            position: relative;
            margin-right: 32px;
            .name_c {
              border-bottom: 1px solid #eee;
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              z-index: 999;
            }
            span {
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              display: block;
              height: 12px;
              background: rgba(250, 220, 30, 1);
            }
          }
        }
        .work_box_content {
          padding: 24px 30px 0 30px;

          .topic_top {
            font-size: 20px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 32px;
            .number {
              float: left;
              span {
                font-size: 25px;
                color: rgba(255, 0, 54, 1);
              }
            }
            .type {
              float: left;
              margin-left: 19px;
              line-height: 36px;
            }
          }
          .topic_bottom {
            border-bottom: 1px solid #eee;
            margin-bottom: 32px;
            .work_name {
              // width: 587px;
              font-size: 18px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 40px;
            }
            .answer {
              .answer_list {
                line-height: 32px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                margin-bottom: 42px;
                span {
                  cursor: pointer;
                  float: left;
                  width: 34px;
                  height: 34px;
                  background: rgba(255, 255, 255, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  text-align: center;
                  line-height: 34px;
                  border-radius: 50%;
                  margin-right: 24px;
                }
                .answer-check {
                  background: rgba(250, 220, 30, 0.5);
                  border: 2px solid rgba(250, 220, 30, 1);
                  color: #333;
                }
                .more {
                  border-radius: 4px;
                }
                .work_key{
                  white-space: pre-wrap;
                }
              }
              .el-textarea {
                width: 587px;
                margin-bottom: 50px;
              }
            }
          }
          // 解析
          .min_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 33px;
            span {
              display: block;
              float: left;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              margin-right: 16px;
            }
          }
          .resolve {
            .trueanswer {
              font-size: 16px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 26px;
              span {
                font-size: 18px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
          .alt {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 24px;
          }
          .textarea_box {
            .btn {
              cursor: pointer;
              float: right;
              width: 85px;
              height: 33px;
              background: rgba(250, 220, 30, 1);
              border-radius: 4px;
              margin-top: 16px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
              text-align: center;
              line-height: 33px;
            }
          }
          .certain {
            .certain_btn {
              cursor: pointer;
              margin: auto;
              width: 258px;
              height: 37px;
              background: rgba(238, 238, 238, 0.6);
              border-radius: 4px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              text-align: center;
              line-height: 37px;
            }
            .huang {
              background-color: #fadc1e;
              color: #333;
            }
          }
          .operate_box {
            margin-top: 80px;
            .operate_box_l {
              float: left;
              .up,
              .next {
                cursor: pointer;
                float: left;
                width: 73px;
                height: 31px;
                background: rgba(0, 69, 96, 0.04);
                border: 1px solid rgba(238, 238, 238, 1);
                font-size: 16px;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                text-align: center;
                line-height: 31px;
              }
              .next {
                margin-left: 42px;
              }
              .hui {
                border: 1px solid rgba(238, 238, 238, 1);
                background: rgba(238, 238, 238, 1);
                color: rgba(153, 153, 153, 1);
              }
            }
            .operate_box_r {
              float: right;
              .mark {
                float: left;
                margin-right: 54px;
                line-height: 24px;
                margin-top: 7px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                .mark_c {
                  cursor: pointer;
                  float: left;
                  width: 24px;
                  height: 24px;
                  background: rgba(249, 249, 249, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  border-radius: 50%;
                  margin-right: 10px;
                }
                .huang {
                  background-color: #fadc1e;
                  border: 1px solid #fadc1e;
                }
              }
              .faver,
              .show_resolve {
                cursor: pointer;
                float: left;
                background: rgba(0, 69, 96, 0.04);
                border-radius: 4px;
                border: 1px solid rgba(238, 238, 238, 1);
                padding: 7px 12px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                img {
                  float: left;
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                }
              }
              .show_resolve {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 422px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .topic_card {
        padding: 0 42px;
        .card_alt {
          padding-bottom: 21px;
          border-bottom: 1px solid #eee;
          margin-bottom: 34px;
          .card_alt_item {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 12px;
            margin-right: 18px;
            span {
              float: left;
              display: block;
              width: 12px;
              height: 12px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(204, 204, 204, 1);
              border-radius: 50%;
              margin-right: 5px;
            }
            .red {
              background: rgba(232, 66, 51, 0.2);
              border: 1px solid rgba(232, 66, 51, 1);
            }
            .lv {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
            }
            .huang {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
            }
            .mark {
              background: rgba(12, 213, 109, 1);
              border: 1px solid rgba(204, 204, 204, 1);
            }
          }
        }
        .topic_card_box {
          height: 500px;
          overflow-y: scroll;
          margin-bottom: 30px;
          .topic_card_item {
            margin-bottom: 34px;
            .card_item_title {
              font-size: 16px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 21px;
            }
            .card_box {
              border-bottom: 1px solid #eee;
              .number_list {
                cursor: pointer;
                float: left;
                width: 34px;
                height: 34px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                font-size: 14px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 34px;
                border-radius: 50%;
                margin-right: 35px;
                margin-bottom: 20px;
                &:nth-of-type(5n) {
                  margin-right: 0;
                }
              }
              .lv {
                background: rgba(12, 213, 109, 0.2);
                border: 1px solid rgba(12, 213, 109, 1);
                color: rgba(12, 213, 109, 1);
              }
              .huang {
                background: rgba(12, 213, 109, 0.2);
                border: 1px solid rgba(12, 213, 109, 1);
              }
              .red {
                background: rgba(232, 66, 51, 0.2) !important;
                border: 1px solid rgba(232, 66, 51, 1) !important;
                color: rgba(232, 66, 51, 1) !important;
              }
              .mark {
                background: rgba(12, 213, 109, 1);
                border: 1px solid rgba(204, 204, 204, 1);
              }
            }
          }
        }
        /*修改滚动条样式*/
        .topic_card_box::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .topic_card_box::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .topic_card_box::-webkit-scrollbar-thumb {
          background: #0cd56d;
          border-radius: 10px;
        }
        .topic_card_box::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .topic_card_box::-webkit-scrollbar-corner {
          background: #179a16;
        }
        .new_make {
          cursor: pointer;
          width: 258px;
          height: 37px;
          background: rgba(238, 238, 238, 0.6);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          line-height: 37px;
          margin: 0 auto 50px auto;
        }
        .huang {
          background-color: #0cd56d;
        }
      }
    }
    .content_box_r {
      float: right;
      width: 913px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_r_title {
        padding: 20px 0 24px 51px;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        border-bottom: 1px solid #eee;
        img {
          float: left;
          width: 31px;
          height: 32px;
          margin-right: 16px;
        }
      }
      .work_box {
        padding: 0 50px 80px 50px;

        .work_box_title {
          padding: 21px 0;
          border-bottom: 1px solid #eee;
          .name {
            cursor: pointer;
            float: left;
            position: relative;
            margin-right: 32px;
            .name_c {
              border-bottom: 1px solid #eee;
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              z-index: 999;
            }
            span {
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              display: block;
              height: 12px;
              background: #0cd56d;
            }
          }
        }
        .work_box_content {
          padding: 24px 30px 0 30px;

          .topic_top {
            font-size: 20px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 32px;
            .number {
              float: left;
              span {
                font-size: 25px;
                color: rgba(255, 0, 54, 1);
              }
            }
            .type {
              float: left;
              margin-left: 19px;
              line-height: 36px;
            }
          }
          .topic_bottom {
            border-bottom: 1px solid #eee;
            margin-bottom: 32px;
            .work_name {
              // width: 587px;
              font-size: 18px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 40px;
            }
            .answer {
              .answer_list {
                line-height: 32px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                margin-bottom: 42px;
                span {
                  cursor: pointer;
                  float: left;
                  width: 34px;
                  height: 34px;
                  background: rgba(255, 255, 255, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  text-align: center;
                  line-height: 34px;
                  border-radius: 50%;
                  margin-right: 24px;
                }
                .answer-check {
                  background: rgba(12, 213, 109, 0.5);
                  border: 2px solid #0cd56d;
                  color: #333;
                }
                .more {
                  border-radius: 4px;
                }
                .work_key{
                  white-space: pre-wrap;
                }
              }
              .el-textarea {
                width: 587px;
                margin-bottom: 50px;
              }
            }
          }
          // 解析
          .min_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 33px;
            span {
              display: block;
              float: left;
              width: 6px;
              height: 30px;
              background: #0cd56d;
              border-radius: 3px;
              margin-right: 16px;
            }
          }
          .resolve {
            .trueanswer {
              font-size: 16px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 26px;
              span {
                font-size: 18px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
          .alt {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 24px;
          }
          .textarea_box {
            .btn {
              cursor: pointer;
              float: right;
              width: 85px;
              height: 33px;
              background: #0cd56d;
              border-radius: 4px;
              margin-top: 16px;
              font-size: 16px;
              font-weight: 500;
              color: #fff;
              line-height: 22px;
              text-align: center;
              line-height: 33px;
            }
          }
          .certain {
            .certain_btn {
              cursor: pointer;
              margin: auto;
              width: 258px;
              height: 37px;
              background: rgba(238, 238, 238, 0.6);
              border-radius: 4px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              text-align: center;
              line-height: 37px;
            }
            .huang {
              background-color: #0cd56d;
              color: #333;
            }
          }
          .operate_box {
            margin-top: 80px;
            .operate_box_l {
              float: left;
              .up,
              .next {
                cursor: pointer;
                float: left;
                width: 73px;
                height: 31px;
                background: rgba(0, 69, 96, 0.04);
                border: 1px solid rgba(238, 238, 238, 1);
                font-size: 16px;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                text-align: center;
                line-height: 31px;
              }
              .next {
                margin-left: 42px;
              }
              .hui {
                border: 1px solid rgba(238, 238, 238, 1);
                background: rgba(238, 238, 238, 1);
                color: rgba(153, 153, 153, 1);
              }
            }
            .operate_box_r {
              float: right;
              .mark {
                float: left;
                margin-right: 54px;
                line-height: 24px;
                margin-top: 7px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                .mark_c {
                  cursor: pointer;
                  float: left;
                  width: 24px;
                  height: 24px;
                  background: rgba(249, 249, 249, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  border-radius: 50%;
                  margin-right: 10px;
                }
                .huang {
                  background-color: #0cd56d;
                  border: 1px solid #0cd56d;
                }
              }
              .faver,
              .show_resolve {
                cursor: pointer;
                float: left;
                background: rgba(0, 69, 96, 0.04);
                border-radius: 4px;
                border: 1px solid rgba(238, 238, 238, 1);
                padding: 7px 12px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                img {
                  float: left;
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                }
              }
              .show_resolve {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.zg_report{
  background: #FFF !important;
  border: 1px solid #DCDFE6 !important;
  color: #606266 !important;
}
.zg_dafen{
  color: #FFF !important;
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}
</style>